// extracted by mini-css-extract-plugin
export default {"wrap":"Building_wrap__CgJMe","disable":"Building_disable__Jd8va","mobile":"Building_mobile__NDmCc","hidden":"Building_hidden__FOJZ2","bg":"Building_bg__5TkPL"};